import { getIsCallIncoming, getShouldShowActiveCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { getCallStatus } from 'calling-cross-tab-library/appData/operators/widgetDetailsOperators';
import { getData } from 'calling-lifecycle-internal/async-flux-utils/operators/getApiProperties';

// @ts-expect-error not typed
import SearchableCalleeList from 'calling-ui-library/callee-select/components/SearchableCalleeList';
// @ts-expect-error module not typed
import CurrentSettingsInfoWorkspace from './CurrentSettingsInfoWorkspace';
import { getCallableObjectAndAssociations } from 'calling-lifecycle-internal/callee-omnibus/operators/calleeOmnibusResultGetters';
import { useWidgetDetails } from 'calling-cross-tab-library/external/useWidgetDetails';
import { getIsMinutesUsageOverLimit } from 'calling-lifecycle-internal/calls-v1-settings-usage/operators/MinuteUsageSummaryGetters';
import { useMemo, useState } from 'react';
import { CallSource } from 'calling-cross-tab-library/constants/CallSource';
import { INBOX } from 'calling-internal-common/constants/appIdentifiers';
import { hasPaidSeatAccess } from 'calling-orchestration-shared-library/hub-info/utils/hasCallingFeature';
import { View } from 'foundations-components/components/View';
import { getIsTwilioBasedCallProvider } from 'calling-lifecycle-internal/call-provider/operators/getIsTwilioBasedCallProvider';
import { Spacer } from 'foundations-components/components/Spacer';
import ChangeProviderButtonWrapper from './ChangeProviderButtonWrapper';
import { CALLEE_NUMBERS } from 'calling-integration-sdk-support/viewport/constants/changeProviderButtonLocations';
import { getHubSpotCallingEnabled, getInstalledCallingApplications, getPhoneNumbers } from '../../callee-omnibus/operators/settingsOmnibusResultGetters';
import { getHasMultipleProviders } from '../utils/getHasMultipleProviders';
import { useHandleOpenWindowAndStartCall } from 'calling-ui-library/calling-remote-redesign/hooks/useHandleOpenWindowAndStartCall';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CallSettingsNumbersWorkspace = props => {
  const {
    appIdentifier,
    defaultFromNumber,
    channelAssignedPhoneNumbers,
    isKnownVisitor,
    visitorPhoneNumber,
    ticketId,
    threadId,
    gates
  } = props;
  const {
    widgetDetails
  } = useWidgetDetails();
  const crossTabCallStatus = getCallStatus(widgetDetails);
  const isMinutesUsageOverLimit = getIsMinutesUsageOverLimit(props.minutesUsage);
  const [selectedFromNumber, setSelectedFromNumber] = useState(defaultFromNumber);
  const isInbox = appIdentifier === INBOX;
  const source = isInbox ? CallSource.INBOX : CallSource.HELP_DESK;
  const {
    asyncCalleeOmnibus,
    widgetState,
    selectedCallProvider,
    asyncSettingsOmnibus
  } = props;
  const calleeOmnibusData = getData(asyncCalleeOmnibus);
  const calleesData = calleeOmnibusData && getCallableObjectAndAssociations(calleeOmnibusData);
  const shouldShowActiveWidgetCallState = getShouldShowActiveCallState(widgetState.get('callStatus'));
  const isFreeCalling = !hasPaidSeatAccess();
  const isCrossTabCallStatusActive = getShouldShowActiveCallState(crossTabCallStatus) || getIsCallIncoming(crossTabCallStatus);
  const disabledTooltipMessage = !selectedFromNumber ? 'callSettingsOptions.noSelectedFromNumber' : isFreeCalling ? 'callSettingsOptions.freeSeatHubSpotCallingBlocked' : isMinutesUsageOverLimit ? `callSettingsOptions.minutesUsageOverLimit` : isCrossTabCallStatusActive || shouldShowActiveWidgetCallState ? 'callSettingsOptions.callActiveOutboundCallBlocked' : null;
  const settingsOmnibusData = getData(asyncSettingsOmnibus);
  const installedCallingApplications = getInstalledCallingApplications(settingsOmnibusData);
  const hasMultipleProviders = useMemo(() => getHasMultipleProviders({
    installedCallingApplicationsLength: (installedCallingApplications === null || installedCallingApplications === void 0 ? void 0 : installedCallingApplications.length) || 0,
    fromNumbers: getPhoneNumbers(settingsOmnibusData),
    isHubSpotEnabled: getHubSpotCallingEnabled(selectedCallProvider)
  }), [installedCallingApplications, settingsOmnibusData, selectedCallProvider]);
  const {
    startOutboundCall
  } = useHandleOpenWindowAndStartCall({
    defaultFromNumber,
    selectedCallProvider,
    onCallButtonClick: props.onCallButtonClick,
    appIdentifier,
    gates,
    source,
    threadId: threadId ? parseInt(threadId, 10) : undefined,
    ticketId,
    requireContactOrCompany: isKnownVisitor
  });
  return /*#__PURE__*/_jsxs(View, {
    maxBlockSize: "400px",
    overflow: "auto",
    as: "div",
    children: [/*#__PURE__*/_jsx(SearchableCalleeList, {
      appIdentifier: appIdentifier,
      calleesData: calleesData,
      onSelectToNumber: startOutboundCall,
      disabled: !!disabledTooltipMessage,
      canEdit: false,
      showAddPropertyButton: false,
      disabledTooltipMessage: disabledTooltipMessage,
      isKnownVisitor: isKnownVisitor,
      visitorPhoneNumber: visitorPhoneNumber
    }), /*#__PURE__*/_jsxs(View, {
      position: "sticky",
      insetBlockEnd: "0px",
      backgroundColor: "fill-surface-default",
      borderBlockStartWidth: "200",
      borderBlockStartStyle: "solid",
      borderBlockStartColor: "border-core-disabled",
      as: "div",
      children: [/*#__PURE__*/_jsx(CurrentSettingsInfoWorkspace, {
        selectedCallProvider: selectedCallProvider,
        selectedFromNumber: selectedFromNumber,
        onSelectFromNumber: setSelectedFromNumber,
        channelAssignedPhoneNumbers: channelAssignedPhoneNumbers,
        defaultPhoneNumber: defaultFromNumber,
        appIdentifier: appIdentifier,
        showFromNumberDropdown: getIsTwilioBasedCallProvider(selectedCallProvider)
      }), hasMultipleProviders && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ChangeProviderButtonWrapper, {
          providerName: selectedCallProvider.name,
          location: CALLEE_NUMBERS,
          gates: gates
        }), /*#__PURE__*/_jsx(Spacer, {
          space: "100"
        })]
      })]
    })]
  });
};
export default CallSettingsNumbersWorkspace;